import React from 'react';

import BlogArticle from 'components/blog/blogArticle';
import ImageModal from 'components/ui/image-modal';
import { authorKamil as author } from 'data/authors';

import img from 'img/blog/updates/key_shortcuts.png';

const Content = () => {
  return (
    <div>
      <p>
        We&apos;ve added an ability to control session playback by keyboard. Down below you can see
        available shortcuts.
      </p>
      <ImageModal
        src={img}
        alt="keyboard shortcuts"
        title="LiveSession offer you to control session playback by keyboard"
      />
      <p className="mt-3" />
    </div>
  );
};

const Wrapped = BlogArticle(Content);

export const frontmatter = {
  title: 'Keyboard shortcuts',
  url: '/blog/keyboard-shortcuts/',
  description: 'Control player using keyboard',
  author,
  img,
  date: '2019-05-20',
  category: 'Product Updates',
  group: 'updates',
};

export default () => (
  <Wrapped
    title={frontmatter.title}
    category={frontmatter.category}
    description={frontmatter.description}
    date={frontmatter.date}
    author={frontmatter.author}
    url={frontmatter.url}
    group={frontmatter.group}
  />
);
